export default "__VITE_ASSET__C8Hry2Bx__"